var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRt3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffbe9",
      stroke: "none"
    },
    d: "M0 0L0 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M64 100L65 101L64 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M64 103L65 103L69 101L64 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#423863",
      stroke: "none"
    },
    d: "M63 115C55.4179 110.262 52.0735 105.008 43 109L49 122C14.6155 135.036 20.9809 182.227 21 211L30 210C31.9512 221.339 36.5777 222 47 222C47.2157 216.976 47.3713 208.332 50.7384 204.318C53.4251 201.115 59.3518 201.447 63 199.622C72.3223 194.959 76.6617 185.93 78 176C100.488 180.19 125.11 185.811 148 186L150 145L151 145L164.742 176L171.39 187.972L183 189.424L216 192C216 180.796 214.985 169.877 212.116 159C210.015 151.037 206.828 143.045 202.536 136C176.151 92.6822 114.43 106.421 73 112L74 100C64.0739 100.434 63.383 106.079 63 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M49 105L50 106L49 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M47 106L48 107L47 106M51 106L52 107L51 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M63 106L64 107L63 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M106 106L106 107L112 107L106 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M112 106L112 107L118 107L112 106M140 106L140 107L148 107L140 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M148 106L148 107L152 107L148 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M152 106L153 107L152 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M46 107L47 108L46 107M52 107L53 108L52 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M63 107L64 108L63 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M73 107L73 112L74 112L73 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M97.6667 107.333L98.3333 107.667L97.6667 107.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M99 107L99 108L102 108L99 107M158.667 107.333L159.333 107.667L158.667 107.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M160 107L161 108L160 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M44 108L45 109L44 108M63.3333 108.667L63.6667 109.333L63.3333 108.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M90 108L91 109L90 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M91 108L92 109L91 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M92.6667 108.333L93.3333 108.667L92.6667 108.333M163 108L164 109L163 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M164 108L165 109L164 108M55 109L56 110L55 109M84 109L85 110L84 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M85.6667 109.333L86.3333 109.667L85.6667 109.333M167 109L168 110L167 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M168 109L169 110L168 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M43 110L44 111L43 110M56 110L57 111L56 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M78 110L79 111L78 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M79.6667 110.333L80.3333 110.667L79.6667 110.333M170 110L171 111L170 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M171 110L172 111L171 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M57 111L58 112L57 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M74 111L75 112L74 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M75.6667 111.333L76.3333 111.667L75.6667 111.333M173 111L174 112L173 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M174 111L175 112L174 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M44 112L45 113L44 112M176 112L177 113L176 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M60 113L61 114L60 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M178 113L179 114L178 113M45 114L46 115L45 114M61 114L62 115L61 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M62 114L63 115L62 114M180 114L181 115L180 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M182 115L183 116L182 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M46 116L47 117L46 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M183 116L184 117L183 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M185 117L186 118L185 117M47 118L48 119L47 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M186 118L187 119L186 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M48.3333 120.667L48.6667 121.333L48.3333 120.667M189 120L190 121L189 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M190 121L191 122L190 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M46 122L47 123L46 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M191 122L192 123L191 122M45 123L46 124L45 123M192 123L193 124L192 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M43 124L44 125L43 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M193 124L194 125L193 124M42 125L43 126L42 125M194 125L195 126L194 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M40 126L41 127L40 126M195 126L196 127L195 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M384 126L385 127L384 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M321 170C324.343 170.432 329.377 172.516 332.621 171.307C336.762 169.765 340.801 162.147 344.001 159.015C350.329 152.821 357.883 148.349 366 144.873C407.86 126.947 451.38 149.704 470 189C472.856 187.898 479.095 186.752 480.303 183.581C481.623 180.115 478.273 174.904 476.688 172C471.052 161.676 463.395 152.707 454 145.665C425.69 124.446 380.415 119.38 349 136.309C336.493 143.049 321.701 154.695 321 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M394.667 126.333L395.333 126.667L394.667 126.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M39 127L40 128L39 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M196 127L197 128L196 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M376 127L377 128L376 127M404 127L405 128L404 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M38 128L39 129L38 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M370 128L371 129L370 128M411 128L412 129L411 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M37 129L38 130L37 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M416 129L417 130L416 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M198 130L199 131L198 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M199 131L200 132L199 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M424 131L425 132L424 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M34 132L35 133L34 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M357 132L358 133L357 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M33 133L34 134L33 133M32 134L33 135L32 134M201 134L202 135L201 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M31 135L32 136L31 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M202 135L203 136L202 135M438 136L439 137L438 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M203 137L204 138L203 137M29 138L30 139L29 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M345 138L346 139L345 138M390 138L391 139L390 138M399.667 138.333L400.333 138.667L399.667 138.333M442 138L443 139L442 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M204 139L205 140L204 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M383 139L384 140L383 139M408 139L409 140L408 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M28 140L29 141L28 140M205 141L206 142L205 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M417 141L418 142L417 141M447 141L448 142L447 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M27 142L28 143L27 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M420 142L421 143L420 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M206 143L207 144L206 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M423 143L424 144L423 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M26 144L27 145L26 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M366 144L367 145L366 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M26 145L27 146L26 145M150 145L151 146L150 145M207 145L208 146L207 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M453 145L454 146L453 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M150 146L151 147L150 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M25 147L26 148L25 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M150 147L148 187L78 177C75.9814 191.917 64.8075 201.822 50 203L47 222C35.2891 222.008 33.3339 221.234 29 210C24.0714 210.919 19.0563 211.103 15.5579 215.189C4.13678 228.529 22.266 248.212 37 243C41.2552 253.167 48.191 262.273 56.0039 269.985C59.9067 273.838 66.3525 277.217 68.9722 282.09C71.1492 286.138 70 292.532 70 297C55.8909 297 41.978 296.887 29 303.377C7.61558 314.07 5.50692 334.71 4.98534 356C4.44573 378.026 5.22221 400.02 8 422L73 422L73 404C95.2882 404 117.808 403.155 140 405.094C147.712 405.768 150.295 413.275 157 415.991C174.115 422.922 186.313 406.659 192 393L217 396C213.396 383.435 186.032 372.983 174 372C172.038 347.145 175.838 308.78 146 300L146 299C178.499 292.697 204.86 276.5 212 242L211 242C196.095 262.19 167.495 249.223 167 226L149 226C143.343 249.817 123.311 250.547 105 242C103.59 245.538 102.448 249.047 99.7863 251.895C78.6794 274.481 54.851 228.277 85 223.519C89.1362 222.867 93.1484 224.747 97 226C97.0081 213.72 101.997 202.735 114 197.533C130.727 190.284 148.641 205.159 149 222L168 223C174.091 201.896 202.206 196.207 213 217L214 217L213 192C203.656 191.923 194.334 190.243 185 190.015C180.889 189.914 174.83 191.167 171.39 188.397C159.884 179.129 160.301 157.615 150 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M151 147L152 148L151 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M208 147L209 148L208 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M333 147L334 148L333 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M208 148L209 149L208 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M332 148L333 149L332 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M152 149L153 150L152 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M331 149L332 150L331 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M24 150L25 151L24 150M209 150L210 151L209 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M330 150L331 151L330 150M437 150L438 151L437 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M24 151L25 152L24 151M153 151L154 152L153 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M329 151L330 152L329 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M153 152L154 153L153 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M440 152L441 153L440 152M23 153L24 154L23 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M210 153L211 154L210 153M23.3333 154.667L23.6667 155.333L23.3333 154.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M154 154L155 155L154 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M348 154L349 155L348 154M393 154L393 155L396 155L393 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M354 189C369.266 167.388 396.426 159.143 419 174.36C430.209 181.915 435.447 200.441 450 194C437.752 164.736 405.802 145.692 375 158.873C364.617 163.316 337.508 178.641 354 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M399 154L400 155L399 154M443 154L444 155L443 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M149 155L149 161L150 161L149 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M211 155L212 156L211 155M386 155L387 156L386 155M406 155L407 156L406 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M155 156L156 157L155 156M211 156L212 157L211 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M325 156L326 157L325 156M465 156L466 157L465 156M378 157L379 158L378 157M413 157L414 158L413 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M22 158L23 159L22 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M156 158L157 159L156 158M22.3333 159.667L22.6667 160.333L22.3333 159.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M212 159L213 160L212 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M157 160L158 161L157 160M212 160L213 161L212 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M149 161L149 165L150 165L149 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M158 162L159 163L158 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M213 163L214 164L213 163M21 164L22 165L21 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M159 164L160 165L159 164M213 164L214 165L213 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M321 164L322 165L321 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M21 165L21 168L22 168L21 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M159 165L160 166L159 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M472 165L473 166L472 165M386 166L387 167L386 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M160 167L161 168L160 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M404 167L405 168L404 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M214 168L215 169L214 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M320 168L321 169L320 168M359 168L360 169L359 168M379 168L380 169L379 168M407 168L408 169L407 168M431 168L432 169L431 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M161 169L162 170L161 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M214.333 169.667L214.667 170.333L214.333 169.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M459 169L460 170L459 169M412 170L413 171L412 170M20 171L21 172L20 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M162 171L163 172L162 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M329 171L330 172L329 171M373 171L374 172L373 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M20.3333 172.667L20.6667 173.333L20.3333 172.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M148 172L148 179L149 179L148 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M416 172L417 173L416 172M461 172L462 173L461 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M163 173L164 174L163 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M215 173L216 174L215 173M436 173L437 174L436 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M20 174L20 179L21 179L20 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M215 174L216 175L215 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M164 175L165 176L164 175M215 175L215 178L216 178L215 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M367 175L368 176L367 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M78 176L78 177L81 177L78 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M422 176L423 177L422 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M84 177L85 178L84 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M85 177L85 178L88 178L85 177M165 177L166 178L165 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M464 177L465 178L464 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M90.6667 178.333L91.3333 178.667L90.6667 178.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M92.6667 178.333L93.3333 178.667L92.6667 178.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M165 178L166 179L165 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M77.3333 179.667L77.6667 180.333L77.3333 179.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M97 179L98 180L97 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M98.6667 179.333L99.3333 179.667L98.6667 179.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M148 179L148 182L149 182L148 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M166 179L167 180L166 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M441 179L442 180L441 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M103 180L104 181L103 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M104 180L104 181L107 181L104 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M166 180L167 181L166 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M480 180L481 181L480 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M110 181L111 182L110 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M111 181L111 182L114 182L111 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M360 181L361 182L360 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M116.667 182.333L117.333 182.667L116.667 182.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M118.667 182.333L119.333 182.667L118.667 182.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M167 182L168 183L167 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M216 182L217 183L216 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M76 183L77 184L76 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M122.667 183.333L123.333 183.667L122.667 183.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M124.667 183.333L125.333 183.667L124.667 183.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M216 183L216 186L217 186L216 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M481 183L482 184L481 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M76 184L77 185L76 184M130 184L131 185L130 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M131.667 184.333L132.333 184.667L131.667 184.333M168 184L169 185L168 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M136.667 185.333L137.333 185.667L136.667 185.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M138 185L138 186L141 186L138 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M387 185L388 186L387 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M376 203L377 203C393.956 190.072 402.658 198.862 418 209C428.558 190.925 396.463 182.244 384 186.7C375.722 189.659 370.137 195.028 376 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M445 185L446 186L445 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M75 186L76 187L75 186M144.667 186.333L145.333 186.667L144.667 186.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M146.667 186.333L147.333 186.667L146.667 186.333M169 186L170 187L169 186M216 186L216 192L217 192L216 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M350 186L351 187L350 186M355 186L356 187L355 186M384 186L385 187L384 186M354 187L355 188L354 187M381 187L382 188L381 187M473 187L474 188L473 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M74 188L75 189L74 188M170 188L171 189L170 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M171 189L171 190L174 190L171 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M174 189L174 190L184 190L174 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M73 190L74 191L73 190M190 190L190 191L194 191L190 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M194 190L194 191L199 191L194 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M411 190L412 191L411 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M72 191L73 192L72 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M205 191L205 192L208 192L205 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M208 191L208 192L211 192L208 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M214.667 192.333L215.333 192.667L214.667 192.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M216 192L217 193L216 192M414 193L415 194L414 193M449 194L450 195L449 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M69 195L70 196L69 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M390 195L391 196L390 195M438 195L439 196L438 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M116 196L117 197L116 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M117.667 196.333L118.333 196.667L117.667 196.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#423863",
      stroke: "none"
    },
    d: "M168 226C168.015 231.414 168.573 236.216 171.363 240.999C188.382 270.169 233.179 235.804 208.895 211.093C206.13 208.279 202.81 206.037 199 204.939C194.842 203.74 190.205 203.71 186 204.681C174.674 207.294 174.726 217.013 166.725 221.972C162.43 224.635 153.909 223 149 223C148.754 217.364 147.512 211.687 144.2 207.004C123.537 177.785 79.6197 214.11 104.185 239.907C107.189 243.061 110.885 245.266 115 246.637C119.41 248.108 124.439 248.518 129 247.471C135.533 245.971 141.43 241.61 145.03 236C146.902 233.083 147.468 228.029 150.43 226.028C154.743 223.114 163.098 225.959 168 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M127 196L128 197L127 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M128 196L129 197L128 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M387 196L388 197L387 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M66 197L67 198L66 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M113 197L114 198L113 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M114 197L115 198L114 197M131 197L132 198L131 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M132 197L133 198L132 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M417 197L418 198L417 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M65 198L66 199L65 198M111 198L112 199L111 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M133 198L134 199L133 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M134 198L135 199L134 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M63 199L64 200L63 199M117.667 199.333L118.333 199.667L117.667 199.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M119 199L120 200L119 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M120 199.468C90.2045 204.522 97.2663 249.874 127 244.671C155.633 239.662 148.447 194.643 120 199.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M126 199L127 200L126 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M127 199L128 200L127 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M136 199L137 200L136 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M381 199L382 200L381 199M405 199L406 200L405 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M61 200L62 201L61 200M108 200L109 201L108 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M115 200L116 201L115 200M130 200L131 201L130 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M137 200L138 201L137 200M20 201L20 207L21 207L20 201M58 201L59 202L58 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M59 201L60 202L59 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M107 201L108 202L107 201M112 201L113 202L112 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M132 201L133 202L132 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M133 201L134 202L133 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M139 201L140 202L139 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M51 202L51 203L55 203L51 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M111 202L112 203L111 202M134 202L135 203L134 202M140 202L141 203L140 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M109 203L110 204L109 203M136 203L137 204L136 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M141 203L142 204L141 203M190 203L190 204L195 204L190 203M108 204L109 205L108 204M137 204L138 205L137 204M142 204L143 205L142 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M185.667 204.333L186.333 204.667L185.667 204.333M197.667 204.333L198.333 204.667L197.667 204.333M49.3333 205.667L49.6667 206.333L49.3333 205.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M143 205L144 206L143 205M182 205L183 206L182 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M201 205L202 206L201 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M413 205L414 206L413 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M102 206L103 207L102 206M180 206L181 207L180 206M188 206L188 207L194 207L188 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M203 206L204 207L203 206M20.3333 207.667L20.6667 208.333L20.3333 207.667M49 207L50 208L49 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M101 207L102 208L101 207M144 207L145 208L144 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M178 207L179 208L178 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M185 207L186 208L185 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M186 207L187 208L186 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M187 207.519C160.798 213.193 169.425 253.987 196 248.521C222.897 242.988 213.712 201.733 187 207.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M196 207L197 208L196 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M197 207L198 208L197 207M204 207L205 208L204 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M100 208L101 209L100 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M104 208L105 209L104 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M141 208L142 209L141 208M145 208L146 209L145 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M177 208L178 209L177 208M182 208L183 209L182 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M183 208L184 209L183 208M199 208L200 209L199 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M200 208L201 209L200 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M206 208L207 209L206 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M20 209L21 210L20 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M103 209L104 210L103 209M142 209L143 210L142 209M180 209L181 210L180 209M202 209L203 210L202 209M207 209L208 210L207 209M23 210L23 211L26 211L23 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M26 210L27 211L26 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M29 210L30 211L29 210M48 210L48 213L49 213L48 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M99 210L100 211L99 210M146 210L147 211L146 210M174 210L175 211L174 210M179 210L180 211L179 210M203 210L204 211L203 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M208 210L209 211L208 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M389 210L390 211L389 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M390 210.533C369.857 215.421 376.952 247.006 397 242.47C418.086 237.699 410.974 205.443 390 210.533M29 211L30 212L29 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M102 211L103 212L102 211M143 211L144 212L143 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M173 211L174 212L173 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M205 211L206 212L205 211M209 211L210 212L209 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M147 212L148 213L147 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M206 212L207 213L206 212M210 212L211 213L210 212M30 213L31 214L30 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M48 213L49 214L48 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M98 213L99 214L98 213M101 213L102 214L101 213M144 213L145 214L144 213M147 213L148 214L147 213M207 213L208 214L207 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M211 213L212 214L211 213M101 214L102 215L101 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M171 214L172 215L171 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M382 214L383 215L382 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M31 215L32 216L31 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M148 215L149 216L148 215M174 215L175 216L174 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M212 215L213 216L212 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M381 215L382 216L381 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M31 216L32 217L31 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M47.3333 216.667L47.6667 217.333L47.3333 216.667M97.3333 216.667L97.6667 217.333L97.3333 216.667M100 216L101 217L100 216M145 216L146 217L145 216M148.333 216.667L148.667 217.333L148.333 216.667M170 216L171 217L170 216M173 216L174 217L173 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M209 216L210 217L209 216M100 217L101 218L100 217M145 217L146 218L145 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M213 217L214 218L213 217M32 218L33 219L32 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M47 218L48 219L47 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M169 218L170 219L169 218M172 218L173 219L172 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M210 218L211 219L210 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M214 218L215 219L214 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M32 219L33 220L32 219M214 219L215 220L214 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M125.667 220.333L126.333 220.667L125.667 220.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#423863",
      stroke: "none"
    },
    d: "M127.015 220.667C117.826 222.561 120.533 236.911 129.985 234.952C139.309 233.02 136.393 218.733 127.015 220.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M130 220L131 221L130 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M131 220L132 221L131 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M168.333 220.667L168.667 221.333L168.333 220.667M171 220L172 221L171 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M211 220L212 221L211 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M378 220L379 221L378 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M33 221L34 222L33 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M133 221L134 222L133 221M171 221L172 222L171 221M34 222L34 223L38 223L34 222M134 222L135 223L134 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M146 222L147 223L146 222M149 222L149 223L152 223L149 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M152 222L152 223L157 223L152 222M215 222L216 223L215 222M106 241C100.917 236.859 99.8369 228.543 94.7724 225.279C75.0258 212.55 58.2518 250.027 82 257.2C84.8424 258.058 88.0913 258.239 91 257.61C94.2454 256.908 97.4462 255.139 99.7863 252.787C102.979 249.578 104.195 245.035 106 241M135 223L136 224L135 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M170.333 223.667L170.667 224.333L170.333 223.667M212 223L213 224L212 223M215.333 223.667L215.667 224.333L215.333 223.667M121 224L122 225L121 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M188 224L189 225L188 224M212 224L213 225L212 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M377 224L378 225L377 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M149 225L149 226L152 226L149 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M152 225L152 226L161 226L152 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M170 225L170 230L171 230L170 225M184 225L185 226L184 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#423863",
      stroke: "none"
    },
    d: "M185.059 226.032C176.67 230.498 183.282 243.767 191.891 238.971C200.014 234.446 193.22 221.686 185.059 226.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M191 225L192 226L191 225M97.3333 226.667L97.6667 227.333L97.3333 226.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M100 226L101 227L100 226M136 226L137 227L136 226M145 226L146 227L145 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M167 226L167 232L168 232L167 226M183 226L184 227L183 226M100.333 227.667L100.667 228.333L100.333 227.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M120.333 227.667L120.667 228.333L120.333 227.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M136.333 227.667L136.667 228.333L136.333 227.667M145.333 227.667L145.667 228.333L145.333 227.667M148.333 227.667L148.667 228.333L148.333 227.667M182 227L183 228L182 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M194 227L195 228L194 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M181 228L182 229L181 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M377 228L378 229L377 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M136 229L137 230L136 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M195 229L196 230L195 229M98.3333 230.667L98.6667 231.333L98.3333 230.667M101 230L102 231L101 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M144 230L145 231L144 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M170 230L170 233L171 233L170 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M180 230L181 231L180 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M121 231L122 232L121 231M135 231L136 232L135 231M147 231L148 232L147 231M180 231L180 235L181 235L180 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M212 231L213 232L212 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M215.333 231.667L215.667 232.333L215.333 231.667M102 232L103 233L102 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M143 232L144 233L143 232M167 232L168 233L167 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M212.333 232.667L212.667 233.333L212.333 232.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M378 232L379 233L378 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M99 233L100 234L99 233M146 233L147 234L146 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M146 243L166 244C161.875 230.969 151.317 230.361 146 243M215 233L216 234L215 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M103 234L104 235L103 234M124 234L125 235L124 234M132 234L133 235L132 234M142 234L143 235L142 234M168.333 234.667L168.667 235.333L168.333 234.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M171 234L172 235L171 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M379 234L380 235L379 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M100 235L101 236L100 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M125 235L126 236L125 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M126 235L127 236L126 235M128 235L128 236L131 236L128 235M145 235L146 236L145 235M171 235L172 236L171 235M195 235L196 236L195 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M211 235L212 236L211 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M101 236L102 237L101 236M141 236L142 237L141 236M181 236L182 237L181 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M195 236L196 237L195 236M214 236L215 237L214 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M105 237L106 238L105 237M140 237L141 238L140 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M144 237L145 238L144 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M169 237L170 238L169 237M172 237L173 238L172 237M194 237L195 238L194 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M210 237L211 238L210 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M106 238L107 239L106 238M139 238L140 239L139 238M143 238L144 239L143 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M169 238L170 239L169 238M182 238L183 239L182 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M193 238L194 239L193 238M210 238L211 239L210 238M213 238L214 239L213 238M103 239L104 240L103 239M107 239L108 240L107 239M138 239L139 240L138 239M142 239L143 240L142 239M170 239L171 240L170 239M173 239L174 240L173 239M184 239L185 240L184 239M192 239L193 240L192 239M209 239L210 240L209 239M104 240L105 241L104 240M108 240L109 241L108 240M137 240L138 241L137 240M141 240L142 241L141 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M174 240L175 241L174 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M186 240L186 241L190 241L186 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M190 240L191 241L190 240M208 240L209 241L208 240M212 240L213 241L212 240M110 241L111 242L110 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M135 241L136 242L135 241M140 241L141 242L140 241M171 241L172 242L171 241M211 241L212 242L211 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M106 242L107 243L106 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M111 242L112 243L111 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M133 242L134 243L133 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M139 242L140 243L139 242M108 243L109 244L108 243M113 243L114 244L113 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M114 243L115 244L114 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M131 243L132 244L131 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M138 243L139 244L138 243M210 243L211 244L210 243M109 244L110 245L109 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M116 244L117 245L116 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M117 244L118 245L117 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M128.667 244.333L129.333 244.667L128.667 244.333M136 244L137 245L136 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M173 244L174 245L173 244M204 244L205 245L204 244M209 244L210 245L209 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M111 245L112 246L111 245M134 245L135 246L134 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M135 245L136 246L135 245M174 245L175 246L174 245M179 245L180 246L179 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M203 245L204 246L203 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M208 245L209 246L208 245M113 246L114 247L113 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M114 246L115 247L114 246M132 246L133 247L132 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M175 246L176 247L175 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M180 246L181 247L180 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M201 246L202 247L201 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M202 246L203 247L202 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M207 246L208 247L207 246M116 247L117 248L116 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M117 247L118 248L117 247M129 247L130 248L129 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M130 247L131 248L130 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M182 247L183 248L182 247M200 247L201 248L200 247M205 247L206 248L205 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M121 248L121 249L126 249L121 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M178 248L179 249L178 248M185 248L186 249L185 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M186 248L187 249L186 248M196 248L197 249L196 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M197 248L198 249L197 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M204 248L205 249L204 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M180 249L181 250L180 249M202 249L203 250L202 249M182 250L183 251L182 250M200 250L201 251L200 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M184 251L185 252L184 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M185 251L186 252L185 251M196.667 251.333L197.333 251.667L196.667 251.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M190 252L190 253L193 253L190 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M138 262L141 261L138 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#423863",
      stroke: "none"
    },
    d: "M139 261C143.312 271.614 158.625 271.442 165 263L152 264.721L139 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M142 261L143 262L142 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M161 261L161 262L164 262L161 261M143 262L144 263L143 262M159 262L160 263L159 262M164 262L165 263L164 262M139 263L140 264L139 263M145 263L146 264L145 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M146 263L147 264L146 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M157 263L158 264L157 263M140 264L141 265L140 264M149.667 264.333L150.333 264.667L149.667 264.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M151.667 264.333L152.333 264.667L151.667 264.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M153 264L153 265L156 265L153 264M164 264L165 265L164 264M163 265L164 266L163 265M142 266L143 267L142 266M162 266L163 267L162 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M143 267L144 268L143 267M161 267L162 268L161 267M145 268L146 269L145 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M146 268L147 269L146 268M158 268L159 269L158 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M159 268L160 269L159 268M149 269L150 270L149 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M150 269L150 270L156 270L150 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M156 269L157 270L156 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M284 290L284 291L496 291L476 290L433 290L284 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M496 290L497 291L496 290M283 291L284 292L283 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#423863",
      stroke: "none"
    },
    d: "M73 405L73 422L334 422L403 422L429.606 420.972L435.694 410L448.424 381L496 291L347 291L304 291C298.603 291 290.222 289.424 285.213 291.603C278.234 294.64 273.055 312.396 269.753 319L240.247 378C236.634 385.225 232.96 398.282 226.61 403.397C218.131 410.225 198.292 402.677 188.015 405.318C179.579 407.485 176.084 417.329 166 417.892C155.184 418.496 152.447 407.63 143.896 406.148C121.171 402.211 96.02 405 73 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M495 292L496 293L495 292M282 293L283 294L282 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M494 293L495 294L494 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M281 295L282 296L281 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M493 295L494 296L493 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M280 297L281 298L280 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M492 297L493 298L492 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M279 299L280 300L279 299M491 299L492 300L491 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M490 300L491 301L490 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M278 301L279 302L278 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M489 302L490 303L489 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M277 303L278 304L277 303M488 304L489 305L488 304M276 305L277 306L276 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M487 306L488 307L487 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M275 307L276 308L275 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M486 307L487 308L486 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M274 309L275 310L274 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M485 309L486 310L485 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M273 311L274 312L273 311M484 311L485 312L484 311M272 313L273 314L272 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M483 313L484 314L483 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M482 314L483 315L482 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M271 315L272 316L271 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M481 316L482 317L481 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M270 317L271 318L270 317M480 318L481 319L480 318M269 319L270 320L269 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M479 319L480 320L479 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M268 321L269 322L268 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M478 321L479 322L478 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M267 323L268 324L267 323M477 323L478 324L477 323M266 325L267 326L266 325M476 325L477 326L476 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M475 326L476 327L475 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M265 327L266 328L265 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M474 328L475 329L474 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M264 329L265 330L264 329M473 330L474 331L473 330M263 331L264 332L263 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M472 332L473 333L472 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M262 333L263 334L262 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M471 333L472 334L471 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M261 335L262 336L261 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M470 335L471 336L470 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M260 337L261 338L260 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M363 337L364 338L363 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M364 337L364 338L373 338L364 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M373 337L373 338L377 338L373 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M469 337L470 338L469 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M361 338L360 340L361 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M362.001 338.988C339.033 349.518 357.773 383.984 379.999 372.547C402.427 361.006 384.763 328.553 362.001 338.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M379 338L380 339L379 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M380 338L381 339L380 338M468 338L469 339L468 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M259 339L260 340L259 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M382 339L383 340L382 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M359 340L360 341L359 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M384 340L385 341L384 340M467 340L468 341L467 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M258 341L259 342L258 341M358 341L359 342L358 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M385 341L386 342L385 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M386 342L387 343L386 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M466 342L467 343L466 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M257 343L258 344L257 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M387 343L388 344L387 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M465 344L466 345L465 344M256 345L257 346L256 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M354 345L355 346L354 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M388 345L389 346L388 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M464 345L465 346L464 345M353 346L354 347L353 346M389 346L390 347L389 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M255 347L256 348L255 347M389 347L390 348L389 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M463 347L464 348L463 347M352 348L353 349L352 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M254 349L255 350L254 349M462 349L463 350L462 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M390 350L390 353L391 353L390 350M253 351L254 352L253 351M351 351L352 352L351 351M461 351L462 352L461 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M351.333 352.667L351.667 353.333L351.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M252 353L253 354L252 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M390 353L391 354L390 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M460 353L461 354L460 353M390 354L390 358L391 358L390 354M251 355L252 356L251 355M459 355L460 356L459 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M459 356L460 357L459 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M250 357L251 358L250 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M351.333 357.667L351.667 358.333L351.333 357.667M458 358L459 359L458 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M249 359L250 360L249 359M351 359L352 360L351 359M389.333 360.667L389.667 361.333L389.333 360.667M457 360L458 361L457 360M248 361L249 362L248 361M352 362L353 363L352 362M456 362L457 363L456 362M247 363L248 364L247 363M388 363L389 364L388 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M456 363L457 364L456 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M353 364L354 365L353 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M246 365L247 366L246 365M387 365L388 366L387 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M455 365L456 366L455 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M354 366L355 367L354 366M245 367L246 368L245 367M386 367L387 368L386 367M454 367L455 368L454 367M385 368L386 369L385 368M244 369L245 370L244 369M384 369L385 370L384 369M453 369L454 370L453 369M383 370L384 371L383 370M243 371L244 372L243 371M359 371L360 372L359 371M452 371L453 372L452 371M380 372L381 373L380 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M452 372L453 373L452 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M242 373L243 374L242 373M362 373L363 374L362 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M363 373L364 374L363 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M378 373L379 374L378 373M365 374L366 375L365 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M366 374L367 375L366 374M373 374L374 375L373 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M374 374L374 375L377 375L374 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M451 374L452 375L451 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M241 375L242 376L241 375M450 376L451 377L450 376M240 377L241 378L240 377M449 378L450 379L449 378M239 379L240 380L239 379M448 380L449 381L448 380M238 381L239 382L238 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M448 381L449 382L448 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M237 383L238 384L237 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M447 383L448 384L447 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M236 385L237 386L236 385M446 385L447 386L446 385M235 387L236 388L235 387M445 387L446 388L445 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M445 388L446 389L445 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M234 389L235 390L234 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M444 390L445 391L444 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M233 391L234 392L233 391M443 392L444 393L443 392M232 393L233 394L232 393M442 394L443 395L442 394M231 395L232 396L231 395M441 396L442 397L441 396M230 397L231 398L230 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M441 397L442 398L441 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M229 399L230 400L229 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M440 399L441 400L440 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M228 401L229 402L228 401M439 401L440 402L439 401M227 403L228 404L227 403M438 403L439 404L438 403M73 404L73 405L124 405C110.873 399.492 87.3108 404 73 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M124 404L124 405L128 405L124 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M186 404L186 405L227 405C216.25 400.489 197.696 404 186 404M135 405L135 406L141 406L135 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M141 405L141 406L144 406L141 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M185 405L186 406L185 405M437 405L438 406L437 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M437 406L438 407L437 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M147 407L148 408L147 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M436 408L437 409L436 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M148 409L149 410L148 409M182 409L183 410L182 409M149 410L150 411L149 410M181 410L182 411L181 410M435 410L436 411L435 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M150 411L151 412L150 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M180 411L181 412L180 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M151 412L152 413L151 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M179 412L180 413L179 412M434 412L435 413L434 412M152 413L153 414L152 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M177 413L178 414L177 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fece5c",
      stroke: "none"
    },
    d: "M434 413L435 414L434 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M153 414L154 415L153 414M176 414L177 415L176 414M433 414L434 415L433 414M155 415L156 416L155 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M174 415L175 416L174 415M433 415L434 416L433 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M157 416L158 417L157 416M172 416L173 417L172 416M160.667 417.333L161.333 417.667L160.667 417.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cca1d2",
      stroke: "none"
    },
    d: "M162 417L162 418L167 418L162 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e8988",
      stroke: "none"
    },
    d: "M167 417L167 418L170 418L167 417M432 417L433 418L432 417M431 419L432 420L431 419M430 421L431 422L430 421z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRt3);
export default __webpack_public_path__ + "static/media/rt3.5bdcbebc8693c00a2b1829dd02e66089.svg";
export { ForwardRef as ReactComponent };